<template>
    <div :class="classMainBlock">
        <label :for="id">
            {{ title }}
        </label>
        <input
            :id="id"
            v-model="itemModel"
            :class="classInput"
            :disabled="disabled"
            :name="name"
            :placeholder="placeholder"
            autocomplete="off"
            type="text"
        />
    </div>
</template>

<script>
export default {
    props: ['title', 'id', 'name', 'classMainBlock', 'classInput', 'placeholder', 'disabled', 'maxSpan', 'start', 'end'],
    data: function () {
        return {
            itemModel: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.stylization();
            this.eventChange();
        },
        stylization() {
            let self = this,
                $dateInput = $('input#' + this.id),
                startDate = this.start ? window.moment(this.start, 'YYYY-MM-DD') : window.moment(),
                endDate = this.end ? window.moment(this.end, 'YYYY-MM-DD') : window.moment();

            self.itemModel = startDate.format('YYYY-MM-DD') + ' - ' + endDate.format('YYYY-MM-DD');

            let params = {
                startDate: startDate,
                endDate: endDate,
                locale: {
                    format: 'YYYY-MM-DD',
                },
            };
            if (self.maxSpan > -1) {
                params.maxSpan = {
                    days: self.maxSpan,
                };
            }
            $dateInput
                .daterangepicker(params)
                .on('change', function () {
                    self.$emit('change', this.value);
                });
        },
        eventChange() {
            this.$on('change', function (data) {
                this.itemModel = data;
            });
        },
        getValue() {
            return this.itemModel;
        },
        setValue(data) {
            this.itemModel = data;
        },
        clear() {
            this.itemModel = null;
        },
    },
};
</script>
